const api_key = '633WKThVmnNv-DeUtk9K5ZDUg-K9HWV5D79htY';

export { api_key }; 